import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcDutySchedule from '@/types/table/wkcDutySchedule';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcDutyScheduleData extends WkcDutySchedule {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcDutyScheduleController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcDutyScheduleData>>(API_CONTEXT + '/app/wkcDutySchedule/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcDutyScheduleData>(API_CONTEXT + '/app/wkcDutySchedule/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcDutySchedule/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcDutySchedule/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcDutySchedule/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcDutySchedule/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcDutySchedule/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcDutySchedule/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcDutySchedule/deleteBatch', params, httpOptions);
  }
  static viewDutySchedule(params: ANY_OBJECT) {
    return super.get(API_CONTEXT + '/app/wkcDutySchedule/viewDutySchedule', params);
  }
  static deleteTask(params: ANY_OBJECT) {
    return super.get(API_CONTEXT + '/app/wkcDutySchedule/doDeleteStatus', params);
  }
  static saveTask(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/app/wkcDutySchedule/saveDutySchedule', params);
  }
  static updateTask(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/app/wkcDutySchedule/updateDutySchedule', params);
  }
  static viewById(params: ANY_OBJECT) {
    return super.get(API_CONTEXT + '/app/wkcDutySchedule/viewById', params);
  }
  static viewCopyBusinessData(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/app/wkcDutySchedule/viewCopyBusinessData', params);
  }
  static getUserDutyPermissions(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/app/wkcDutySchedule/getUserDutyPermissions', params);
  }
}
